import { isPlatformBrowser } from '@angular/common';
import { Directive, HostBinding, Inject, Input, OnChanges, PLATFORM_ID } from '@angular/core';

/*
 * Safety on external link and opening in new tabs.
 * Taken from https://coryrylan.com/blog/managing-external-links-safely-in-angular
 */

/* eslint-disable @angular-eslint/directive-selector */
@Directive({
  selector: 'a[href]',
})
/* eslint-enable @angular-eslint/directive-selector */
export class ExternalLinkDirective implements OnChanges {
  @HostBinding('attr.rel') relAttr: string;
  @HostBinding('attr.target') targetAttr: string;
  @HostBinding('attr.href') hrefAttr: string;
  @Input() href: string;
  private readonly WASUrl = '/WAS';

  constructor(
    @Inject(PLATFORM_ID)
    private platformId: string
  ) {}

  ngOnChanges() {
    this.hrefAttr = this.href;
    if (this.isLinkExternal()) {
      // https://developers.google.com/web/tools/lighthouse/audits/noopener
      this.relAttr = 'noopener';
      this.targetAttr = '_blank';
    }
  }

  private isLinkExternal() {
    if (!this.href) {
      return false;
    }

    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    if (this.href.toLowerCase().includes('javascript')) {
      return false;
    }

    const anchorTag = this.getAnchorTag(this.href);
    if (anchorTag.hostname.toLowerCase() !== location.hostname.toLocaleLowerCase()) {
      return true;
    }

    if (this.href === this.WASUrl) {
      return true;
    }

    return false;
  }

  private getAnchorTag(url: string): HTMLAnchorElement {
    const anchorTag = document.createElement('a');
    anchorTag.href = url;

    return anchorTag;
  }
}
